export const organizationReducerKey = 'organizationReducerKey';
export const organizationReducerType = 'organizationReducerType';
export const organizationSetIsLoadingReducerType = 'organizationSetIsLoadingReducerType';
